module.exports = __webpack_public_path__ + "img/sm_action.7469ddb6.png";